/*
TODO: advanced search
this was a fun excuse to get more familiar with React Context but
all this stuff could have just easily been landed in mst
*/
import React from 'react'

import { noop } from '#util'

import { SearchCriteria } from './helpers'

type SearchDispatch = React.Dispatch<React.SetStateAction<SearchCriteria>>

export const defaultCriteria = {
  docType: undefined,
  folderId: undefined,
  includeTitleOnly: false,
  includeTrash: false,
  modifiedAfter: undefined,
  modifiedBefore: undefined,
  phrase: '',
}

export const SearchContext = React.createContext<{
  criteria: SearchCriteria
  setCriteria: SearchDispatch
}>({
  criteria: defaultCriteria,
  setCriteria: noop,
})

export const PendingSearchContext = React.createContext<{
  pendingCriteria: SearchCriteria
  setPendingCriteria: SearchDispatch
  mergePendingCriteria: (val: Partial<SearchCriteria>) => void
}>({
  pendingCriteria: defaultCriteria,
  setPendingCriteria: noop,
  mergePendingCriteria: noop,
})

export const useSearchContext = () => React.useContext(SearchContext)
export const usePendingSearchContext = () =>
  React.useContext(PendingSearchContext)
